import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { useQuery } from '@tanstack/react-query';
import { integrationService, IntegrationType } from '@/services/integrationService';
import { useAuth } from '@/hooks/useAuth';

/**
 * Hook para buscar todas as integrações do usuário
 */
export const useIntegrations = (type?: IntegrationType) => {
  useLanguage();
  const { user } = useAuth();

  return useQuery({
    queryKey: ['integrations', user?.id, type],
    queryFn: () => {
      if (!user?.id) throw new Error(translateInterfaceText("User not authenticated"));
      return integrationService.getAll(user.id, type);
    },
    enabled: !!user?.id,
    refetchOnWindowFocus: false,
  });
};
